<div #container class="relative grow min-w-0 h-[260px]">
  <div #overlay class="absolute inset-0 z-10 pointer-events-none"></div>
</div>

<ng-template
  #pointerPositionXAxisLabel
  let-backgroundColorClass="backgroundColorClass"
  let-minWidth="minWidth"
  let-text="text"
  let-textColorClass="textColorClass"
>
  <div
    class="rounded-[4px] px-1 py-[2px] text-center text-xs font-bold bg-foreground-primary-100 text-foreground-secondary-100 pointer-events-none"
    [class]="backgroundColorClass + ' ' + textColorClass"
    [style.min-width.px]="minWidth"
  >
    {{ text }}
  </div>
</ng-template>
